import { render, staticRenderFns } from "./PT035ProductAllergenSearchParts.vue?vue&type=template&id=059567c6&scoped=true&"
import script from "./PT035ProductAllergenSearchParts.vue?vue&type=script&lang=js&"
export * from "./PT035ProductAllergenSearchParts.vue?vue&type=script&lang=js&"
import style0 from "./PT035ProductAllergenSearchParts.vue?vue&type=style&index=0&id=059567c6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "059567c6",
  null
  
)

export default component.exports